import { render, staticRenderFns } from "./ArticleListItem.vue?vue&type=template&id=a2f8453a&"
import script from "./ArticleListItem.vue?vue&type=script&lang=js&"
export * from "./ArticleListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lili/Sites/southern-highlands.com.au-2018/web/app/themes/wisdom/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('a2f8453a', component.options)
    } else {
      api.reload('a2f8453a', component.options)
    }
    module.hot.accept("./ArticleListItem.vue?vue&type=template&id=a2f8453a&", function () {
      api.rerender('a2f8453a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/ArticleListItem.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/ArticleListItem.vue
// module id = 36
// module chunks = 0 2 3 4 6